import axios from "axios";
import { Especialidade } from "./AxiosRequestEspecialidade";

export class AxiosRequestCidade {
  async get (especialidade: Especialidade, uf: string): Promise<string[]> {
    const params = {
      codigoCategoria: especialidade.Codigo,
      uf
    }
    const response = await axios.get('https://api.cdt.casadebraganca.com/ListarEstadosPorCategoria', { params });
    return response.data.ObjetoRetorno.map((o:any) => o as string);
  }
}